import React from 'react';

const NoContextPage = () => {
  return (
    <div style={{ padding: '50px', textAlign: 'center' }}>
      <h1>无上下文测试页面</h1>
      <p>这个页面不使用任何上下文或钩子</p>
    </div>
  );
};

export default NoContextPage; 